import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import './style.css'

// Font Awesome setup
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faTwitch, faDiscord, faSteam } from '@fortawesome/free-brands-svg-icons'
import { 
  faBullseye, 
  faBolt, 
  faDragon, 
  faGamepad, 
  faChevronRight,
  faDesktop,
  faServer,
  faGift,
  faShield,
  faCog,
  faCheck,
  faExclamationTriangle,
  faSpinner
} from '@fortawesome/free-solid-svg-icons'

library.add(
  // Brand icons
  faTwitch, faDiscord, faSteam,
  // Solid icons
  faBullseye, faBolt, faDragon, faGamepad, faChevronRight,
  faDesktop, faServer, faGift, faShield, faCog, faCheck,
  faExclamationTriangle, faSpinner
)

const app = createApp(App)

app.component('font-awesome-icon', FontAwesomeIcon)
app.use(createPinia())
app.use(router)

app.mount('#app')
